<template>
  <div>
    <PageAllow controller="Settings" action="businessSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("miniDevelopProgram.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_app_id") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_app_id"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_secret") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_secret"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("miniDevelopProgram.wechat_mini_reply_qa_tid") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.wechat_mini_reply_qa_tid"
                  :hint="$t('miniDevelopProgram.hint')"
                  single-line
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("miniDevelopProgram.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("wechatOfficialSetting.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatOfficialSetting.app_id") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.app_id"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatOfficialSetting.timeStamp") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field
                  v-model="settings.timeStamp"
                  single-line
                  dense
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatOfficialSetting.nonceStr") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field v-model="settings.nonceStr" single-line dense>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("wechatOfficialSetting.signature") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                <v-text-field v-model="settings.signature" single-line dense>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("wechatOfficialSetting.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.miniDevelopProgram"),
        disabled: true,
        href: "/settings/mini-develop-program",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getMiNiFromAPI();
  },
  methods: {
    getMiNiFromAPI() {
      Setting.settings(
        "keys[]=wechat_mini_app_id&keys[]=wechat_mini_secret&keys[]=wechat_mini_reply_qa_tid&keys[]=app_id&keys[]=timeStamp&keys[]=nonceStr&keys[]=signature"
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
          }
        }.bind(this)
      );
    },

    save() {
      delete this.settings.distribution_district_unique_enable;
      const arr = [];
      for (let key in this.settings) {
        arr.push({ setting_key: key, setting_value: this.settings[key] });
      }
      Setting.batchSave(arr).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
            this.getMiNiFromAPI();
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>